"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _inline_svg = require("./inline_svg.utils");
var _inline_svg2 = _interopRequireDefault(require("./inline_svg.proptypes"));
var _excluded = ["fontsize", "themeColor"];
var DoubleArrow = function DoubleArrow(props) {
  var theme = _react.default.useContext(_styledComponents.ThemeContext);
  var fontsize = props.fontsize,
    themeColor = props.themeColor,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var _parseStyles = (0, _inline_svg.parseStyles)({
      fontsize: fontsize,
      themeColor: themeColor
    }, theme),
    sizeStyles = _parseStyles.sizeStyles,
    colorStyles = _parseStyles.colorStyles;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, sizeStyles, {
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
    // eslint-disable-next-line max-len
    d: "M0 9.49997L4.8269 4.99998L0 0.5H1.83457L6.66147 4.99998L1.83457 9.49997H0ZM5.87308 9.49997L10.7 4.99998L5.87308 0.5H7.70762L12.5346 4.99998L7.70762 9.49997H5.87308Z",
    fill: "#4B4FA6"
  }, colorStyles)));
};
DoubleArrow.propTypes = _inline_svg2.default.propTypes;
DoubleArrow.defaultProps = _inline_svg2.default.defaultProps;
var _default = DoubleArrow;
exports.default = _default;